import { Mutex } from "async-mutex"

export class MutexMap<K> {
    private mapProtection = new Mutex()
    private individualLocks = new Map<K, Mutex>()

    async getOrCreateMutex(key: K): Promise<Mutex> {
        let mutex: Mutex | undefined
        await this.mapProtection.runExclusive(async () => {
            if (!this.individualLocks.has(key))
                this.individualLocks.set(key, new Mutex())
            mutex = this.individualLocks.get(key)
        })

        if (mutex === undefined)
            throw new Error("Internal error when acquiring object creation lock")

        return mutex
    }

    // You must call delete on the mutex when you are done with it, otherwise it will be leaked
    delete(key: K): void {
        this.individualLocks.delete(key)
    }
}